export const ALLOWED_QUERY_PARAMS = [
  'promo',
  'clickId',
  'affiliate',
  'app',
  'showCourseTitle',
];
